// Lets non-React code (e.g. the authed client's 401 handler) navigate through the
// router instead of a full page reload. main.tsx registers the router's navigate.
let redirect: () => void = () => {};

export const setLoginRedirect = (fn: () => void): void => {
  redirect = fn;
};

export const redirectToLogin = (): void => redirect();
